import { am4core, am4charts } from '@/utils/async_chart_loader'

import createAxisAndSeries from './chartAxis'

/**
 * The legacy signature, kept exactly as it was for the charts that load amCharts eagerly.
 *
 * The helper itself now lives in `chartAxis.ts` and takes the library as arguments; this
 * file is the thin wrapper that supplies the statically imported one, so traforama's
 * dashboard and report charts carry on unchanged. A caller that loads amCharts on demand
 * imports `chartAxis` directly and passes what `loadCharts()` resolved to — that is what
 * keeps the library out of adok's entry chunk.
 */
export default (chart: any, ...rest: any[]) =>
  (createAxisAndSeries as any)(am4core, am4charts, chart, ...rest)
